import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';

import moment from 'moment';

import { connect } from 'react-redux';
import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import RuleTimestampFilter from '../../../components/RuleExceptionsTable/RuleTimestampFilter';
import RuleDebugger from './RuleDebugger';
import ViewTargets from './ViewTargets';
import { isEmpty } from 'lodash';
import { setPageTitle } from '../../../helpers/auth';

import * as DashboardActions from '../../../actions/dashboardActions';
import * as RuleActions from '../../../actions/ruleActions';
import * as SensorTypeActions from '../../../actions/sensorTypeActions';

import classes from './RulesPage.module.css';
import FormulaBuilderTabs from '../FormulaBuilder/FormulaBuilderTabs';

const RulesPage = ({
    activeNavCompany,
    activeRule,
    history,
    setActiveRule,
    fetchRuleList,
    fetchRuleKPIs,
    fetchSensorTypes,
    rules,
    sensorTypes,
    setRuleList,
    ...props
}) => {

    const [isOpenDebugger, setIsOpenDebugger] = useState(false);
    const [isOpenTargets, setIsOpenTargets] = useState(false);
    const [isOpenRuleBuilder, setIsOpenRuleBuilder] = useState(false);

    useEffect(() => {
        return () => {
            setRuleList([], {});
        };
    }, []);

    useEffect(() => {
        const init = async () => {
            if (isEmpty(rules)) {
                const options = {pageSize: 20};
                let promises = [fetchRuleKPIs(), fetchRuleList(activeNavCompany.id, options)];

                if (isEmpty(sensorTypes)) {
                    promises.push(fetchSensorTypes());
                }

                await Promise.all(promises.map(p => p.catch(err => err)));
            }
        };

        if (activeNavCompany.id) init();
       
    }, [activeNavCompany]);

    useEffect(() => {
        if (!isEmpty(activeNavCompany)) {
            if (isOpenDebugger) {
                setPageTitle(activeNavCompany.name, 'Rule Debugger');
            } else if (isOpenTargets) {
                setPageTitle(activeNavCompany.name, 'View Targets');
            } else {
                setPageTitle(activeNavCompany.name, 'Rules');
            }
        }
    }, [activeNavCompany, isOpenDebugger, isOpenTargets]);

    const handleBackClick = () => {
        setIsOpenDebugger(false);
        setActiveRule(null);
        setIsOpenTargets(false);
    };

    return (
        <BobPage>
            <div className={classes.RulesPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    { 
                        !isOpenDebugger && !isOpenTargets  ? 
                            <div className={classes.TitlePanel}>
                                <div className={classes.Name}>
                                    Rules
                                </div> 
                            </div>
                            : null 
                    }
                    {
                        isOpenDebugger || isOpenTargets ?
                            <div className={classes.TitlePanel}>
                                <div className={classes.Name}>
                                    <span>
                                        <span
                                            className={classes.BackIcon}
                                            aria-hidden="true"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() =>
                                                handleBackClick()
                                            }
                                        >
                                            <i className="fas fa-chevron-left" />
                                        </span>
                                        { isOpenTargets ? 'View Targets' : 'Rule Debugger' }
                                    </span> 
                                </div> 
                                {
                                    isOpenTargets ? 
                                        null :
                                        <div className={classes.Date}>
                                            <RuleTimestampFilter
                                                className={classes.TimestampOverride}
                                                maxDate={moment().local()}
                                                minDate={moment().local().subtract(30, 'd')}
                                                disableIntervalSelector={true}
                                            />
                                        </div>
                                }
                            </div> 
                            : null
                    }
                </div>
                <div className={classes.TablePanel}>
                    {
                        !isOpenDebugger && !isOpenTargets && !isOpenRuleBuilder ?
                            <TableContainer
                                setSelectedRule={setActiveRule}
                                setIsOpenDebugger={setIsOpenDebugger}
                                setIsOpenRuleBuilder={setIsOpenRuleBuilder}
                                setIsOpenTargets={setIsOpenTargets}
                                selectedRule={activeRule}
                            />
                            : null
                    }
                    {
                        isOpenRuleBuilder ?
                            <FormulaBuilderTabs />
                            :
                            null
                    }
                    {
                        isOpenDebugger ? 
                            <RuleDebugger 
                                rule={activeRule}
                            />
                            : 
                            null
                    }
                    {
                        isOpenTargets ?
                            <ViewTargets 
                                rule={activeRule}
                            />
                            : 
                            null
                    }
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        activeRule:       state.rules.activeRule,
        rules:            state.rules.ruleList,
        sensorTypes:      state.sensorTypes.data
    };
};

const mapDispatchToProps = {
    ...DashboardActions,
    ...RuleActions,
    ...SensorTypeActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RulesPage));
